<template>
  <v-container>
    <app-city-header :payload="payload"> </app-city-header>

    <!-- Aviso para relatórios aprovados ou em pagamento -->
    <v-row
      v-if="payload.statusRelatorioId === 2 || payload.statusRelatorioId === 4"
    >
      <v-col>
        <v-alert type="info" text dense class="mb-3">
          Relatório disponível apenas para consulta devido ao status de aprovado
          ou processamento de pagamento.
        </v-alert>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        {{ payload.titulo }}
      </v-col>

      <v-col
        cols="2"
        v-if="
          (isAdmin ||
            user.usuarioId === payload.usuarioId ||
            isSPFesp ||
            isSPFespEspecial ||
            isSPCoordenador) &&
          payload.statusRelatorioId != 2 &&
          payload.statusRelatorioId != 4
        "
      >
        <v-btn outlined color="primary" class="ml-3" @click="validar()">
          <span>Atualizar</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          v-model="payload.inicioString"
          v-mask="'##/##/#### ##:##'"
          label="Data de Início"
          placeholder="00/00/0000 00:00"
          disabled
        ></v-text-field>
      </v-col>

      <v-col>
        <v-text-field
          v-model="payload.fimString"
          v-mask="'##/##/#### ##:##'"
          label="Data de Término"
          placeholder="00/00/0000 00:00"
          disabled
        ></v-text-field>
      </v-col>
      <v-col>
        <combobox-encontro-tipo
          :filter="payload"
          @change="onTipoExecucaoChange"
          :readonly="
            verTipoEncontro ||
            payload.statusRelatorioId === 2 ||
            payload.statusRelatorioId === 4
          "
        ></combobox-encontro-tipo>
      </v-col>

      <v-col
        v-if="
          encontroTipoEnum.hibrido !== payload.encontrosTipoId ||
          !relatorioHorasRemotasHorasPresenciais
        "
      >
        <v-text-field
          v-restrict.number
          v-model="payload.horasUtilizadasString"
          label="Horas Utilizadas"
          placeholder="0"
          persistent-hint
          :disabled="
            (!isFullAdmin &&
              !config.editaHorasUtilizadas &&
              !groupsConfig.editaHorasUtilizadas) ||
            payload.statusRelatorioId === 2 ||
            payload.statusRelatorioId === 4
          "
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row
      v-if="
        encontroTipoEnum.hibrido === payload.encontrosTipoId &&
        relatorioHorasRemotasHorasPresenciais
      "
    >
      <v-col>
        <v-text-field
          v-restrict.number
          v-model="payload.horasUtilizadasString"
          label="Horas Utilizadas"
          placeholder="0"
          persistent-hint
          :disabled="
            (!isFullAdmin &&
              !config.editaHorasUtilizadas &&
              !groupsConfig.editaHorasUtilizadas) ||
            payload.statusRelatorioId === 2 ||
            payload.statusRelatorioId === 4
          "
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-restrict.number
          v-model="payload.horasRemotasString"
          label="Horas Remotas"
          placeholder="0"
          persistent-hint
          :disabled="
            payload.statusRelatorioId === 2 || payload.statusRelatorioId === 4
          "
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-restrict.number
          v-model="payload.horasPresenciaisString"
          label="Horas Presenciais"
          placeholder="0"
          persistent-hint
          :disabled="
            payload.statusRelatorioId === 2 || payload.statusRelatorioId === 4
          "
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row
      v-if="
        isFullAdmin ||
        (config.exibirPjAtendida && groupsConfig.exibirPjAtendida) ||
        (config.exibirPfAtendida && groupsConfig.exibirPfAtendida)
      "
    >
      <v-col>
        <v-text-field
          v-if="
            isFullAdmin ||
            (config.exibirPfAtendida && groupsConfig.exibirPfAtendida)
          "
          v-restrict.number
          v-model="payload.pjAtendidas"
          label="Pessoas Físicas Atendidas"
          placeholder="0"
          persistent-hint
          :disabled="
            payload.statusRelatorioId === 2 || payload.statusRelatorioId === 4
          "
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-if="
            isFullAdmin ||
            (config.exibirPjAtendida && groupsConfig.exibirPjAtendida)
          "
          v-restrict.number
          v-model="payload.pfAtendidas"
          label="Empresas Atendidas"
          placeholder="0"
          persistent-hint
          :disabled="
            payload.statusRelatorioId === 2 || payload.statusRelatorioId === 4
          "
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-tabs vertical v-model="tab">
        <v-tab :value="0">
          <v-icon left>mdi-file-chart</v-icon>
          Relatório
        </v-tab>
        <v-tab :value="1">
          <v-icon left>mdi-account-multiple-plus</v-icon>
          Convidados
        </v-tab>
        <v-tab @click="onAnexosTabClick" :value="2">
          <v-icon left>mdi-attachment</v-icon>
          Anexos
        </v-tab>
        <v-tab :value="3">
          <v-icon left>mdi-calendar-check-outline</v-icon>
          {{ isAT || isGov ? "Atividades" : "Tarefas" }}
        </v-tab>
        <v-tab :value="4">
          <v-icon left>mdi-android-messages</v-icon>
          Observações
        </v-tab>

        <v-tab-item>
          <v-col>
            <v-textarea
              label="Relatório do evento"
              v-model="payload.descricao"
              :readonly="
                payload.statusRelatorioId === 2 ||
                payload.statusRelatorioId === 4
              "
              :spellcheck="true"
              autocomplete="on"
              lang="pt-BR"
              class="spell-check-enabled"
            ></v-textarea>
          </v-col>
        </v-tab-item>
        <v-tab-item>
          <v-col>
            <app-modal-insert-member
              :edit="false"
              :color="'success'"
              :icon="'mdi-plus-circle'"
              :municipioId="payload.municipioId"
              @onSave="getMembers"
              v-if="
                (isAdmin ||
                  user.usuarioId === payload.usuarioId ||
                  isSPFesp ||
                  isSPFespEspecial ||
                  isSPCoordenador) &&
                payload.statusRelatorioId != 2 &&
                payload.statusRelatorioId != 4
              "
            >
              <template v-slot:title :edit="false"> Cadastrar Membro </template>
            </app-modal-insert-member>
          </v-col>

          <v-col>
            <v-combobox
              v-model="payload.convidadosRelatorio"
              :items="membros"
              chips
              clearable
              label="Membros"
              item-value="membroId"
              item-text="nome"
              multiple
              :disabled="
                payload.statusRelatorioId === 2 ||
                payload.statusRelatorioId === 4
              "
            >
              <template v-slot:item="{ attrs, item }">
                <!-- HTML that describe how select should render items when the select is open -->
                {{ item.nome | esconderValores("nome") }}
              </template>
              <template v-slot:selection="{ attrs, item }">
                <v-chip close @click:close="removeMembro(item)">
                  <strong
                    >{{ item.nome | esconderValores("nome") }} -
                    {{ item.cpf | esconderValores("cpf") }}</strong
                  >
                </v-chip>
              </template>
            </v-combobox>
          </v-col>

          <v-data-table
            :headers="headersConvidados"
            :items="payload.convidadosRelatorio"
            class="elevation-1"
            hide-default-footer
            disable-pagination
            v-if="
              payload.statusRelatorioId !== 2 && payload.statusRelatorioId !== 4
            "
          >
            <template v-slot:item.presente="{ item }">
              <v-checkbox
                v-model="item.presente"
                :id="'membro' + item.membroId"
                color="primary"
                :disabled="
                  payload.statusRelatorioId === 2 ||
                  payload.statusRelatorioId === 4
                "
              >
              </v-checkbox>
            </template>

            <template v-slot:item.cpf="{ item }">
              {{ item.cpf | esconderValores("cpf") }}
            </template>
            <template v-slot:item.email="{ item }">
              {{ item.email | esconderValores("email") }}
            </template>

            <template v-slot:item.nome="{ item }">
              {{ item.nome | esconderValores("nome") }}
            </template>

            <template slot="no-data">
              <span> Nenhum convidado retornado </span>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-col>
            <template>
              <v-file-input
                multiple
                label="Anexos"
                v-model="payload.currArquivos"
                @change="inputChanged"
                :disabled="
                  payload.statusRelatorioId === 2 ||
                  payload.statusRelatorioId === 4
                "
              >
                <template v-slot:selection="{ index }">
                  <span v-if="index === 0">
                    {{ payload.arquivos?.length }}
                    {{
                      payload.arquivos?.length === 1 ? "arquivo" : "arquivos"
                    }}
                  </span>
                </template>
              </v-file-input>

              <v-alert
                v-if="payload.arquivos?.length"
                type="warning"
                text
                dense
                class="mt-2"
              >
                Existem {{ payload.arquivos?.length }}
                {{
                  payload.arquivos?.length === 1
                    ? "anexo novo pendente"
                    : "anexos novos pendentes"
                }}. Clique em <strong>Atualizar</strong> para salvar no
                relatório.
              </v-alert>
            </template>
          </v-col>
          <v-data-table
            :headers="headersAnexos"
            :items="anexosListagem"
            class="elevation-1"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item.nome="{ item }">
              <span>{{ item.nome }}</span>
              <v-chip
                v-if="item.pendente"
                x-small
                color="warning"
                text-color="white"
                class="ml-2"
              >
                Pendente
              </v-chip>
            </template>

            <template v-slot:item.download="{ item }">
              <template v-if="item.pendente">
                <v-btn
                  outlined
                  color="error"
                  class="ml-3"
                  @click="removePendingFile(item.file)"
                  :disabled="
                    payload.statusRelatorioId === 2 ||
                    payload.statusRelatorioId === 4
                  "
                >
                  <span>Remover</span>
                </v-btn>
              </template>
              <template v-else>
                <v-btn
                  outlined
                  color="primary"
                  class="ml-3"
                  @click="downloadAnexo(item)"
                >
                  <span>Download</span>
                </v-btn>
                <v-btn
                  outlined
                  color="primary"
                  class="ml-3"
                  @click="ExcluirAnexo(item)"
                  :disabled="
                    payload.statusRelatorioId === 2 ||
                    payload.statusRelatorioId === 4
                  "
                >
                  <span>Excluir</span>
                </v-btn>
              </template>
            </template>

            <template slot="no-data">
              <span> Nenhum anexo retornado </span>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-data-table
            :headers="headers"
            :items="payload.tarefas"
            class="elevation-1"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item.cumprida="{ item }">
              <v-checkbox
                v-model="item.cumprida"
                :id="'cumprida' + item.tarefaId"
                color="primary"
                :disabled="true"
              >
              </v-checkbox>
            </template>
            <template
              v-slot:item.tarefa.municipioTarefa.municipioEvidencias="{ item }"
            >
              <span
                v-for="evidencia in item.municipioTarefa.municipioEvidencias"
                :key="evidencia.municipioEvidenciaId"
              >
                {{ evidencia.nome }} |
              </span>
            </template>

            <template slot="no-data">
              <span>
                Nenhuma
                {{ isAT ? "iniciativas" : isGov ? "fases" : "soluções" }}
                retornada
              </span>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-col>
            <v-textarea
              v-model="payload.observacoes"
              :disabled="
                !(isAdmin || payload.usuarioId === user.usuarioId) ||
                payload.statusRelatorioId === 2 ||
                payload.statusRelatorioId === 4
              "
            ></v-textarea>
          </v-col>
        </v-tab-item>
      </v-tabs>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { reportAPI } from "@/modules/report";
import { AppCityHeader } from "@/modules/city";
import { memberAPI } from "@/modules/city/components/MemberAPI";
import AppModalInsertMember from "@/modules/city/components/group/ModalInsertMember";
import AppModalInsertTask from "./ModalInsertTask";
import moment from "moment";
import { cityTaskAPI } from "@/modules/city/API/CityTaskAPI.js";
import ComboboxEncontroTipo from "@/components/calendar/encontroTipo/ComboboxEncontroTipo.vue";
import { encontroTipoEnum } from "@/components/calendar/encontroTipo/encontroTipoEnum.js";
export default {
  components: {
    AppCityHeader,
    AppModalInsertMember,
    AppModalInsertTask,
    ComboboxEncontroTipo,
  },
  data() {
    return {
      tiposExecucao: [
        { name: "Presencial", value: 1 },
        { name: "Remoto", value: 2 },
      ],
      payload: {
        arquivos: [],
        currArquivos: [],
        anexos: [],
        convidadosRelatorio: [],
        tarefas: [],
        tipoExecucaoRelatorio: { name: "Presencial", values: 1 },
        encontrosTipoId: null, // Inicializa explicitamente para reatividade
      },
      encontroTipoEnum: encontroTipoEnum,
      membros: [],
      headers: [
        { text: "Tarefa", value: "municipioTarefa.nome" },
        { text: "Horas", value: "municipioTarefa.horas" },
        { text: "Cumprida", value: "cumprida" },
        {
          text: "Evidências",
          value: "tarefa.municipioTarefa.municipioEvidencias",
        },
      ],
      headersConvidados: [
        { text: "Nome", value: "nome" },
        { text: "CPF", value: "cpf" },
        { text: "E-mail", value: "email" },
        { text: "Presente", value: "presente" },
      ],
      headersAnexos: [
        { text: "Nome", value: "nome" },
        { text: "", value: "download" },
      ],
      estado: this.$store.state.uf,
      user: JSON.parse(localStorage.getItem("user")),
      anexosCarregados: false,
      anexosCache: [],
      tab: 0,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    get() {
      this.setLoading(true);
      reportAPI
        .get(this.$route.params.relatorio)
        .then((resp) => {
          this.payload = {
            ...resp.data,
            arquivos: [],
            currArquivos: [],
            anexos: this.payload.anexos || [],
          };

          // Usa Vue.set para garantir reatividade
          if (this.verTipoEncontro && this.payload.encontro?.encontrosTipoId) {
            this.$set(
              this.payload,
              "encontrosTipoId",
              this.payload.encontro.encontrosTipoId
            );
          } else if (this.payload.tipoExecucaoRelatorioId) {
            this.$set(
              this.payload,
              "encontrosTipoId",
              this.payload.tipoExecucaoRelatorioId
            );
          }
          this.payload.convidadosRelatorio = this.payload.convidados?.map(
            (item) => item.convidado
          );

          for (
            let count = 0;
            count < this.payload.convidadosRelatorio.length;
            count++
          ) {
            this.payload.convidadosRelatorio[count].presente = true;
          }

          this.payload.inicioString = moment(this.payload.inicio).format(
            "DD/MM/YYYY HH:mm"
          );
          this.payload.fimString = moment(this.payload.fim).format(
            "DD/MM/YYYY HH:mm"
          );
          if (this.payload.horasUtilizadasString.indexOf(":") > -1) {
            this.payload.horasUtilizadasString =
              this.payload.horasUtilizadasString.substring(1, 2);
          }

          this.setLoading(false);
          this.payload.tipoExecucaoRelatorio = this.tiposExecucao.find(
            (item) => item.value === this.payload.tipoExecucaoRelatorioId
          );
          this.getMembers();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatório");
        });
    },
    resetarCacheAnexos() {
      this.anexosCarregados = false;
      this.anexosCache = [];
    },
    carregarAnexos() {
      this.setLoading(true);

      reportAPI
        .getRelatorioAnexos(this.$route.params.relatorio)
        .then((resp) => {
          this.anexosCache = resp.data;
          this.$set(this.payload, "anexos", resp.data);
          this.anexosCarregados = true;

          this.setLoading(false);
          this.$forceUpdate();
        })
        .catch((error) => {
          console.error("Erro ao carregar anexos:", error);
          this.$notification.error("Erro ao carregar anexos");
          this.setLoading(false);
        });
    },
    onAnexosTabClick() {
      if (this.anexosCarregados) {
        this.$set(this.payload, "anexos", this.anexosCache);
        return;
      }

      this.carregarAnexos();
    },
    downloadAnexo(evidencia) {
      reportAPI
        .downloadAnexo(evidencia.relatorioAnexoId)
        .then((resp) => {
          let blob = new Blob([resp.data], {
            type: resp.headers["content-type"],
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = evidencia.nome;
          link.click();

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter evidencia");
        });
    },
    ExcluirAnexo(evidencia) {
      this.setLoading(true);
      memberAPI
        .deleteAnexoById(evidencia.relatorioAnexoId)
        .then((resp) => {
          this.carregarAnexos();
          this.$notification.success("Anexo Excluido");
        })
        .catch((resp) => {
          // this.$notification.error('Erro ao atualizar relatório')
          this.$notification.success("Anexo Excluido");
        });
    },

    testaHoras() {
      let contratoId;
      const findContrato =
        this.payload?.encontro?.solucoes[0]?.municipioSolucao?.contratoRelacao
          ?.usuarioId == this.user?.usuarioId;

      if (
        !this.payload?.encontro?.solucoes[0]?.municipioSolucao?.contratoRelacao
      ) {
        this.testarConfirmacao();
      } else {
        let contratoWithMunicipioSolucaoContrato =
          this.payload?.encontro?.solucoes[0]?.municipioSolucao?.municipioSolucaoContrato
            ?.filter(
              (item) => item?.contrato?.usuarioId == this.user?.usuarioId
            )
            .map((item) => item?.contratoId);

        let contratoWithMunicipioSolucao = null;

        if (findContrato) {
          contratoWithMunicipioSolucao =
            this.payload?.encontro?.solucoes[0]?.municipioSolucao
              ?.contratoRelacao?.contratoId;
        }

        contratoId =
          contratoWithMunicipioSolucaoContrato?.length == 0
            ? contratoWithMunicipioSolucao
            : contratoWithMunicipioSolucaoContrato[0];

        if (contratoId) {
          this.setLoading(true);

          cityTaskAPI.testaHoras(contratoId).then((resp) => {
            this.setLoading(false);

            const { data: horas } = resp;
            this.testarConfirmacao(horas);
          });
        } else {
          this.testarConfirmacao();
        }
      }
    },

    testarConfirmacao(horas) {
      let erro = false;
      if (horas) {
        // let verificarDataHorasAgendadas =
        //   this.verificarDataHorasAgendadas(horas);
        let verificarDataHoraAprovadas =
          this.verificarDataHorasAprovadas(horas);

        if (!verificarDataHoraAprovadas) {
          this.$notification.error(
            "As horas utilizadas ultrapassam o limite de horas do contrato"
          );
          erro = true;
        }

        if (!erro) {
          this.update();
        }
      } else {
        this.update();
      }
    },
    verificarDataHorasAgendadas(resp) {
      const soma =
        parseInt(resp.horasAgendadas) +
        parseInt(this.payload?.horasUtilizadasString || 0);

      return resp.qtdHorasPrevistas >= soma;
    },
    verificarDataHorasAprovadas(resp) {
      const soma =
        parseInt(resp.horasAprovadas) +
        parseInt(this.payload?.horasUtilizadasString || 0);

      return resp.qtdHorasPrevistas >= soma;
    },
    validar() {
      if (!this.payload.descricao) {
        this.$notification.error(
          `É necessário preencher o relatório do evento`
        );
        return;
      }
      if (!this.payload.encontroId || this.payload.encontroId === 0) {
        this.$notification.error(
          `${this.isAT ? "A agenda" : "O encontro"} deve estar preenchido`
        );
        return;
      }

      if (
        this.relatorioHorasRemotasHorasPresenciais &&
        this.payload.encontrosTipoId === this.encontroTipoEnum.hibrido
      ) {
        const conta =
          (parseInt(this.payload.horasRemotasString) || 0) +
          (parseInt(this.payload.horasPresenciaisString) || 0);

        const totalHoras = parseInt(this.payload.horasUtilizadasString) || 0;

        if (conta != totalHoras) {
          this.$notification.error(
            "A soma das horas remotas e presenciais deve ser igual ao total de horas utilizadas"
          );
          return;
        }
      }

      if (
        (this.estado === "SC" ||
          this.estado === "MS" ||
          this.estado === "BA" ||
          this.estado === "SP" ||
          this.estado === "MA" ||
          this.estado === "RJ") &&
        !this.payload.horasUtilizadasString
      ) {
        this.payload.horasUtilizadasString = "0";
      } else {
        if (
          this.config.umTarefaValorRelatorio &&
          this.groupsConfig.umTarefaValorRelatorio
        ) {
          if (
            this.payload &&
            this.payload.tarefasRelatorio &&
            this.payload.tarefasRelatorio.length == 1
          ) {
            this.payload.tarefasRelatorio = this.payload.tarefasRelatorio.map(
              (item) => ({
                ...item,
                municipioTarefa: {
                  ...item.municipioTarefa,
                  horas: this.payload.horasUtilizadasString,
                },
              })
            );
          }
        }

        this.testaHoras();
      }
    },

    update() {
      this.setLoading(true);
      let formData = new FormData();

      if (this.payload.arquivos) {
        for (let i = 0; i < this.payload.arquivos.length; i++) {
          formData.append("arquivos", this.payload.arquivos[i]);
        }

        this.anexosCarregados = false;
      }

      if (typeof this.payload.tipoExecucaoRelatorio == "object") {
        this.payload.tipoExecucaoRelatorio =
          this.payload.tipoExecucaoRelatorio.value;
      }

      formData.append("criacao", this.payload.criacao);
      formData.append("descricao", this.payload.descricao);
      formData.append("encontroId", this.payload.encontroId);
      formData.append("usuarioId", this.payload.usuarioId);
      formData.append("municipioId", this.payload.municipioId);
      formData.append("relatorioId", this.payload.relatorioId);
      formData.append("statusRelatorioId", this.payload.statusRelatorioId);
      formData.append("titulo", this.payload.titulo);
      formData.append("tipoExecucaoRelatorioId", this.payload.encontrosTipoId);
      formData.append(
        "horasPrevistasString",
        this.payload.horasPrevistasString
      );
      formData.append(
        "horasUtilizadasString",
        this.payload.horasUtilizadasString
      );
      formData.append("horasRemotasString", this.payload.horasRemotasString);
      formData.append(
        "horasPresenciaisString",
        this.payload.horasPresenciaisString
      );
      formData.append("inicioString", this.payload.inicioString);
      formData.append("fimString", this.payload.fimString);
      formData.append("criacaoString", this.payload.criacaoString);
      formData.append(
        "tarefasRelatorioString",
        JSON.stringify(this.payload.tarefas)
      );
      formData.append(
        "convidadosRelatorioString",
        JSON.stringify(this.payload.convidadosRelatorio)
      );
      formData.append(
        "convidadosString",
        JSON.stringify(this.payload.convidados)
      );
      if (this.payload.pjAtendidas) {
        formData.append("pjAtendidas", this.payload.pjAtendidas);
      }
      if (this.payload.pfAtendidas) {
        formData.append("pfAtendidas", this.payload.pfAtendidas);
      }
      if (this.payload.observacoes) {
        formData.append("observacoes", this.payload.observacoes);
      }
      if (this.payload.motivoRejeicao) {
        formData.append("motivoRejeicao", this.payload.motivoRejeicao);
      }
      if (this.payload.complemento) {
        formData.append("complemento", this.payload.complemento);
      }

      reportAPI
        .update(formData)
        .then((resp) => {
          this.setLoading(false);
          this.payload.arquivos = [];
          this.$notification.success("Relatório Atualizado");
          this.tab = 0;
        })
        .catch((resp) => {
          console.log("🚀 ~ resp:", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao atualizar relatório");
          //this.$notification.success("Relatório Atualizado");
        });
    },
    getMembers() {
      this.setLoading(true);
      memberAPI
        .getMembersByCity(this.$route.params.id)
        .then((resp) => {
          this.membros = resp.data;
          this.onMemberClick();
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter membros");
        });
    },
    addTask(tasks) {
      for (let count = 0; count < tasks.length; count++) {
        this.payload.tarefas.push({
          municipioTarefa: tasks[count],
          municipioTarefaId: tasks[count].municipioTarefaId,
          cumprida: true,
        });
      }
    },
    onMemberClick() {
      for (let count = 0; count < this.membros.length; count++) {
        this.membros[count].presente = true;
      }
    },
    getFileKey(file) {
      return `${file.name}-${file.size}-${file.lastModified}`;
    },
    inputChanged(files) {
      const selectedFiles = Array.isArray(files) ? files : files ? [files] : [];

      if (!selectedFiles.length) {
        this.payload.currArquivos = [];
        return;
      }

      const existingKeys = new Set(
        (this.payload.arquivos || []).map((item) => this.getFileKey(item))
      );

      const newFiles = selectedFiles.filter((file) => {
        const fileKey = this.getFileKey(file);
        if (existingKeys.has(fileKey)) {
          return false;
        }

        existingKeys.add(fileKey);
        return true;
      });

      this.payload.arquivos = [...(this.payload.arquivos || []), ...newFiles];

      this.$nextTick(() => {
        this.payload.currArquivos = [];
      });
    },
    removePendingFile(file) {
      this.payload.arquivos = (this.payload.arquivos || []).filter(
        (item) => item !== file
      );
      this.payload.currArquivos = [];
    },
    onTipoExecucaoChange(value) {
      // Força reatividade quando o tipo de execução muda
      this.payload.encontrosTipoId = value;
      this.$forceUpdate();
    },
  },
  watch: {
    "payload.encontrosTipoId": {
      handler() {
        // Força reatividade dos elementos condicionais
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
    },
  },
  mounted() {
    this.get();

    if (this.isAT || this.isGov) {
      this.headers = [
        { text: "Atividades", value: "municipioTarefa.nome" },
        { text: "Horas", value: "municipioTarefa.horas" },
        { text: "Cumprida", value: "cumprida" },
        {
          text: "Evidências",
          value: "tarefa.municipioTarefa.municipioEvidencias",
        },
      ];
    }
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isAT",
      "isSPFesp",
      "isSPFespEspecial",
      "isSPCoordenador",
      "isFullAdmin",
      "isGov",
      "config",
      "groupsConfig",
    ]),

    verTipoEncontro() {
      return (
        //this.isFullAdmin ||
        this.config.verTipoEncontro && this.groupsConfig.verTipoEncontro
      );
    },
    relatorioHorasRemotasHorasPresenciais() {
      return (
        this.isFullAdmin ||
        (this.config.relatorioHorasRemotasHorasPresenciais &&
          this.groupsConfig.relatorioHorasRemotasHorasPresenciais)
      );
    },
    anexosListagem() {
      const anexosSalvos = (this.payload.anexos || []).map((item) => ({
        ...item,
        pendente: false,
      }));

      const anexosPendentes = (this.payload.arquivos || []).map((file) => ({
        nome: file.name,
        pendente: true,
        file,
      }));

      console.log("Anexos para listagem:", { anexosSalvos, anexosPendentes });

      return [...anexosSalvos, ...anexosPendentes];
    },
  },
};
</script>
